import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/home";
import WebsiteBrandingPage from "./pages/webService";
import LeadServicePage from "./pages/leadService";
import ITServicePage from "./pages/itService";
import AboutPage from "./pages/about";
import ProductsPage from "./pages/products";
import BlogList from "./pages/blogList";
import BlogPost from "./pages/blogPost";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/services/website-branding" element={<WebsiteBrandingPage />} />
        <Route path="/services/lead-generation" element={<LeadServicePage />} />
        <Route path="/services/it-services" element={<ITServicePage />} />
        <Route path="/services/about" element={<AboutPage />} />
        <Route path="/services/products" element={<ProductsPage />} />
        <Route path="/services/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route />
      </Routes>
    </Router>
  );
}

export default App;
